import React from 'react';
import { ClosePanelButton } from './ClosePanelButton';

export const PANEL_PAGE_HEADER_TEST_ID = 'panel-page-header';

interface PanelPageHeaderProps {
  onClose?: () => void;
  closeAriaLabel: string;
  actions?: React.ReactNode;
  endActions?: React.ReactNode;
}

export const PanelPageHeader: React.FC<PanelPageHeaderProps> = ({
  onClose,
  closeAriaLabel,
  actions,
  endActions,
}) => {
  if (!actions && !endActions && !onClose) {
    return null;
  }

  return (
    <div
      data-testid={PANEL_PAGE_HEADER_TEST_ID}
      className="mb-8 flex w-full min-w-0 flex-wrap items-center gap-2"
    >
      {actions}
      {(endActions || onClose) ? (
        <div className="ml-auto flex min-w-0 max-w-full flex-wrap items-center justify-end gap-2">
          {endActions}
          {onClose ? <ClosePanelButton onClick={onClose} ariaLabel={closeAriaLabel} /> : null}
        </div>
      ) : null}
    </div>
  );
};
